import React from 'react';

interface HeadingProps {
  children: React.ReactNode;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
  align?: 'left' | 'center' | 'right';
}

export function Heading({ 
  children, 
  level = 1, 
  className = '',
  align = 'left'
}: HeadingProps) {
  const Tag = `h${level}` as keyof JSX.IntrinsicElements;
  
  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  const sizeClasses = {
    1: 'text-[2.5rem] leading-[1.1] md:text-4xl lg:text-5xl',
    2: 'text-2xl md:text-3xl lg:text-4xl',
    3: 'text-xl md:text-2xl lg:text-3xl',
    4: 'text-lg md:text-xl lg:text-2xl',
    5: 'text-base md:text-lg lg:text-xl',
    6: 'text-sm md:text-base lg:text-lg'
  };
  
  return (
    <Tag 
      className={`font-gabarito font-bold ${alignmentClasses[align]} ${sizeClasses[level]} ${className}`}
      style={{ textRendering: 'optimizeLegibility' }}
    >
      {children}
    </Tag>
  );
}